import { render, staticRenderFns } from "./SupervisedModal.vue?vue&type=template&id=03643d52&scoped=true"
import script from "./SupervisedModal.vue?vue&type=script&lang=js"
export * from "./SupervisedModal.vue?vue&type=script&lang=js"
import style0 from "./SupervisedModal.vue?vue&type=style&index=0&id=03643d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03643d52",
  null
  
)

export default component.exports